import React, { useEffect, useState } from "react";
import Navbar from "designs/design1New/Navbar/Navbar";
import Spinner from "components/helpers/Spinner";
import dayjs from "dayjs";
import { useParams } from "react-router-dom";
import { fetchAxiosNoToken } from "helpers/fetchAxiosNoToken";
import NavbarCorredor from "pages/landingCorredor/NavbarCorredor";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

export interface Visita {
    id: string;
    fecha: string;
    hora_inicio: string;
    hora_final: string;
    nota: string;
    estado: string;

    casa: Casa;
    usuario: Client;
}

export interface Casa {
    id: string;
    nombre: string;
    banner: string;
}

export interface Client {
    id: string;
    nombre: string;
    apellido: string;
    correo: string;
    celular: string;
}

const CancelByEmail = () => {
    const { id, by } = useParams();
    const [loading, setLoading] = useState(false);

    const [visita, setVisita] = useState<Visita | null>(null);
    const navigate = useNavigate();
    useEffect(() => {
        getVisita();
    }, [id]);

    const getVisita = async () => {
        setLoading(true);

        const data = await fetchAxiosNoToken({
            url: `/visitas_agendadas/getOneVisitaAgendada/${id}`,
            method: "get",
        });
        console.log(data);
        setVisita(data);

        setLoading(false);
    };

    const handleCancel = async () => {
        const result = await Swal.fire({
            title: "¿Estás seguro?",
            text: "Esta acción cancelará la visita.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, cancelar",
            cancelButtonText: "No, volver",
        });

        if (result.isConfirmed) {
            setLoading(true);
            try {
                const response = await fetchAxiosNoToken({
                    url: `/visitas_agendadas/deleteByEmail/${id}/${by}`,
                    method: "put",
                });

                Swal.fire({
                    title: "Visita Cancelada",
                    text: "La visita ha sido cancelada.",
                    icon: "success",
                    confirmButtonText: "Aceptar",
                }).then(() => {
                    navigate("/");
                });
            } catch (error) {
                Swal.fire("Error", "No se pudo cancelar la visita.", "error");
            } finally {
                setLoading(false);
            }
        }
    };

    return (
        <div>
            <NavbarCorredor />
            <div className="flex justify-center items-center w-full px-4">
                {loading ? (
                    <div className="flex items-center justify-center w-full ">
                        <Spinner />
                    </div>
                ) : !visita ? (
                    <div className="w-[350px] text-center shadow-lg p-6 bg-white rounded-lg">
                        <h2 className="text-2xl font-bold text-gray-800">
                            No se encontró la visita agendada.
                        </h2>
                        <p className="mt-4 text-gray-600">
                            Por favor, verifica el ID de la visita o intenta
                            nuevamente más tarde.
                        </p>
                        <div className="mt-6">
                            <button
                                onClick={() => window.open("/", "_self")}
                                className="px-4 py-2 bg-blue-blueFrom text-white hover:scale-105 cursor-pointer rounded-lg"
                            >
                                Ir a página principal
                            </button>
                        </div>
                    </div>
                ) : (
                    <div className="w-[350px] text-gray-800 shadow-lg p-6 bg-white rounded-lg">
                        <div>
                            <div className=" font-bold text-center text-2xl ">
                                Cancelar Visita
                            </div>
                            <div className="text-base text-gray-600 text-center mb-4 mt-3">
                                Esta acción no se podrá deshacer.
                            </div>
                        </div>
                        <div>
                            <div className="grid gap-4">
                                <div className="flex flex-col gap-2">
                                    <label
                                        className="font-semibold"
                                        htmlFor="patientName"
                                    >
                                        Nombre:
                                    </label>
                                    <input
                                        type="text"
                                        disabled
                                        id="patientName"
                                        value={`${visita.usuario.nombre} ${visita.usuario.apellido}`}
                                        readOnly
                                        className="border border-gray-300 rounded-lg p-2"
                                    />
                                </div>
                                <div className="flex flex-col gap-2">
                                    <label
                                        className="font-semibold"
                                        htmlFor="turnDate"
                                    >
                                        Fecha de visita:
                                    </label>
                                    <input
                                        type="text"
                                        disabled
                                        id="turnDate"
                                        value={dayjs(visita.fecha).format(
                                            "DD/MM/YYYY"
                                        )}
                                        readOnly
                                        className="border border-gray-300 rounded-lg p-2"
                                    />
                                </div>
                                <div className="flex flex-col gap-2">
                                    <label
                                        className="font-semibold"
                                        htmlFor="turnTime"
                                    >
                                        Hora de Visita:
                                    </label>
                                    <input
                                        type="text"
                                        disabled
                                        id="turnTime"
                                        value={visita.hora_inicio.substring(
                                            0,
                                            5
                                        )}
                                        readOnly
                                        className="border border-gray-300 rounded-lg p-2"
                                    />
                                </div>
                                <div className="flex flex-col gap-2">
                                    <label
                                        className="font-semibold"
                                        htmlFor="turnAddress"
                                    >
                                        Casa:
                                    </label>
                                    <div className="flex flex-col items-center gap-2">
                                        <img
                                            src={`${process.env.REACT_APP_PROXY}/casa/getImage/${visita.casa.banner}`}
                                            alt="Casa"
                                            className=" w-40 h-40 object-cover rounded-full"
                                        />
                                        <div className="font-semibold text-base text-center">
                                            {visita.casa.nombre}{" "}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <button
                                disabled={loading}
                                className="w-full bg-blue-blueFrom hover:scale-105 mt-5 p-2 text-white rounded-lg transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
                                onClick={() => handleCancel()}
                            >
                                {loading ? (
                                    <>
                                        <Spinner />
                                        Cancelando
                                    </>
                                ) : (
                                    "Cancelar visita"
                                )}
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CancelByEmail;
